module.exports = __webpack_public_path__ + "static/media/18ECA49.33d219e0.jpg";